import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { hasPermission } from '../../utils/utils';
import { Organisation } from '../../models/organisation.model';
import { Page } from '../../models/page.model';
import { OrganisationService } from '../../services/organisation.service';
import { OrganisationEditComponent } from './organisation-edit.component';

import { KeycloakService } from '../../services/keycloak.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'organisations-cmp',
  templateUrl: 'organisations.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, OrganisationEditComponent, FormsModule, CommonModule, TranslatePipe, PaginationModule],
  providers: [OrganisationService],
})
export class OrganisationComponent implements OnInit, AfterViewInit {
  organisations: Organisation[];

  error: any;
  @ViewChild('term') term: ElementRef;

  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public filter: string = '';
  showRef: boolean;

  constructor(
    private organisationService: OrganisationService,
    private router: Router,
  ) {
    //		let roles : string[] = KeycloakService.auth.authz.tokenParsed.realm_access.roles;
    //		let setRoles : Set<string> = new Set<string>(roles);
    //		this.showRef = setRoles.has('ROLE_ADMIN');
    this.showRef =
      KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN') || KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR');
  }

  getOrganisationsPaginated(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: string) {
    this.organisationService
      .getOrganisationsAdvanced(pageIndex, this.itemsPerPage, sortColumnName, sortColumnOrder, filter, true)
      .subscribe((page) => this.handlePage(page));
  }

  handlePage(page: Page<Organisation>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
  }

  addOrganisation() {
    this.router.navigate(['/organisations', 'new']);
  }

  deleteOrganisation(organisation: Organisation, event: any) {
    event.stopPropagation();
    this.organisationService.delete(organisation).subscribe(
      (res) => {
        this.onChangeTable();
      },
      (error) => (this.error = error),
    );
  }

  editOrganisation(organisation: Organisation, event: any) {
    this.router.navigate(['/organisations', 'edit', organisation.id]);
  }

  ngOnInit() {
    if (hasPermission(['ROLE_ADMIN', 'ROLE_SECTOR', 'ROLE_NEGOCE'], ['/home'], this.router)) {
      this.onChangeTable();
    }
  }

  ngAfterViewInit() {
    fromEvent(this.term.nativeElement, 'keyup')
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((term: any) => {
        this.filter = <string>term.target.value;
        this.updateFilters();
      });
  }

  updateFilters() {
    // reset la page à la première et update la table
    // FIXME faire mieux : suspendre le traitement des changements ?
    if (this.page === 1) {
      this.onChangeTable();
    } else {
      // le biding (pagechanged) du contrôle de pagination va appeler onChangeTable
      this.page = 1;
    }
  }

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    console.log('onChangeTable');
    const pageNumber = page.page;
    this.getOrganisationsPaginated(pageNumber, 'id', 'desc', this.filter);
  }
}
